import _sfc_main from "./component-library330.mjs";
import "./component-library331.mjs";
import normalizeComponent from "./component-library95.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "offer-tile-variant" }, [_setup.mappedVariants.length > 0 ? _c(_setup.VariantSelector, { staticClass: "offer-tile-variant__variant", attrs: { "type": _vm.type, "hide-name": "", "variants": _setup.mappedVariants }, on: { "select-variant": (args) => _vm.$emit("select-variant", args) } }) : _vm._e(), _vm.limit && _vm.limit < _vm.variants.length ? _c("div", { staticClass: "offer-tile-variant__limit" }, [_vm._v(" + " + _vm._s(_vm.variants.length - _vm.limit) + " ")]) : _vm._e()], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "fd0d39a5",
  null,
  null
);
const OfferTileVariant = __component__.exports;
export {
  OfferTileVariant as default
};
